import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { restrictToVerticalAxis, restrictToWindowEdges } from "@dnd-kit/modifiers";
import { SortableContext, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Dropdown } from "react-bootstrap";

import { ColumnDropdownItem } from "src/components/columnDropdown/columnDropdownItem.tsx";

interface ColumnDropdownProps<T> {
  items: {
    key: T;
    value: string;
  }[];
  selectedColumns: T[];
  setSelectedColumns: (columns: T[]) => void;
  setColumnOrder: (order: T[]) => void;
}

export const ColumnDropdown = <T extends string>({
  items,
  selectedColumns,
  setSelectedColumns,
  setColumnOrder,
}: ColumnDropdownProps<T>) => {
  const selectedColumnsCount = items.filter((c) => selectedColumns.includes(c.key)).length;

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over !== null && active.id !== over.id) {
      const oldIndex = items.findIndex((i) => i.key === active.id);
      const newIndex = items.findIndex((i) => i.key === over.id);

      setColumnOrder(
        arrayMove(
          items.map((i) => i.key),
          oldIndex,
          newIndex
        )
      );
    }
  };

  const toggleColumn = (column: T): void => {
    if (selectedColumns.indexOf(column) >= 0) {
      setSelectedColumns(selectedColumns.filter((c) => c !== column));
    } else {
      setSelectedColumns([...selectedColumns, column]);
    }
  };

  return (
    <Dropdown autoClose="outside">
      <Dropdown.Toggle variant="primary" id="dropdown-basic">
        Select Columns ({selectedColumnsCount}/{items.length})
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <DndContext onDragEnd={handleDragEnd} modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}>
          <SortableContext items={items.map((c) => c.key)} strategy={verticalListSortingStrategy}>
            {items.map((c) => (
              <ColumnDropdownItem
                key={c.key}
                id={c.key}
                checked={selectedColumns.indexOf(c.key) >= 0}
                toggleColumn={() => toggleColumn(c.key)}
                value={c.value}
              />
            ))}
          </SortableContext>
        </DndContext>
      </Dropdown.Menu>
    </Dropdown>
  );
};
